export default __webpack_public_path__ + "static/media/test.1be82882.jpg";